
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function BottomNavigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const navItems = [
    {
      path: '/home',
      icon: 'ri-home-line',
      activeIcon: 'ri-home-fill',
      label: 'الرئيسية'
    },
    {
      path: '/search',
      icon: 'ri-search-line',
      activeIcon: 'ri-search-fill',
      label: 'البحث'
    },
    {
      path: '/history',
      icon: 'ri-history-line',
      activeIcon: 'ri-history-fill',
      label: 'السجل'
    },
    {
      path: '/profile',
      icon: 'ri-user-line',
      activeIcon: 'ri-user-fill',
      label: 'الملف الشخصي'
    }
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 z-50 shadow-lg">
      <div className="grid grid-cols-4 h-16">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center justify-center space-y-1 transition-all duration-200 ${
                isActive ? 'text-purple-600' : 'text-gray-400 hover:text-gray-600'
              }`}
            >
              <i className={`${isActive ? item.activeIcon : item.icon} text-lg w-6 h-6 flex items-center justify-center`}></i>
              <span className="text-xs font-medium">{item.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
